import {
    EventStreamDataset,
    IAttribute,
    ICopySinkWithUpdateMethod,
    IModel,
    Metamodel,
    UpdateMethod,
    UpdateMethodType
} from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { TabularCopySink } from './tabular.copysink';

@Metamodel.model({
    name: adfModelTypeMap.eventStream.copySinkType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(EventStreamDataset) }
})
export class EventStreamCopySink extends TabularCopySink implements ICopySinkWithUpdateMethod {
    public static readonly MODEL: IModel;
    public static readonly WRITE_BEHAVIOR: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BEHAVIOR',
        display: stringResources.ModelName_WriteBehavior
    })
    public writeBehavior?: string = UpdateMethod.Append;

    public get updateMethod(): UpdateMethodType {
        return this.writeBehavior as UpdateMethodType;
    }

    public set updateMethod(value: UpdateMethodType) {
        this.writeBehavior = value;
    }
}
